export function getYouTubeId(url) {
  if (!url) return null;
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
  return m ? m[1] : null;
}

export function YouTubeEmbed({ url, short }) {
  const id = getYouTubeId(url);
  if (!id) return null;
  if (short) {
    return (
      <div className="mx-auto my-6 rounded-lg overflow-hidden border border-slate-200 bg-black" style={{ maxWidth: 340, aspectRatio: "9/16" }} data-testid="youtube-short">
        <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${id}`} title="YouTube Short" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      </div>
    );
  }
  return (
    <div className="my-6 rounded-lg overflow-hidden border border-slate-200 bg-black" style={{ aspectRatio: "16/9" }} data-testid="youtube-embed">
      <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${id}`} title="YouTube video" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
    </div>
  );
}
